import { AssistantOutlinedIcon } from "icons";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";

interface IAIAnswerSection {
  title: string;
}

const AIAnswerSection = ({ title }: IAIAnswerSection) => (
  <Box>
    <SectionHeader
      label={
        <Stack direction="row" alignItems="center" gap={0.8}>
          {title}
          <AssistantOutlinedIcon sx={{ width: "20px", height: "20px" }} />
        </Stack>
      }
    />
    <SectionContent>
      <Text>This is an example {title} text.</Text>
    </SectionContent>
  </Box>
);

export default AIAnswerSection;
